module.exports.tagsJson = [{
  type: 'tags',
  id: '81b684fb-526a-4463-a7ea-e3480b03ec30',
  attributes: {
    value: 'Jewellery',
  },
  selected: false,
}, {
  type: 'tags',
  id: '0da63934-3606-458f-8502-bc82eeedaa16',
  attributes: {
    value: 'Fashion',
  },
  selected: false,
}, {
  type: 'tags',
  id: '84c5c823-86dd-481a-9870-6867a6c22d6a',
  attributes: {
    value: 'Beauty',
  },
  selected: false,
}, {
  type: 'tags',
  id: '31e48572-3d67-4309-8bb9-ccf7ad12e9c9',
  attributes: {
    value: 'Skincare',
  },
  selected: false,
}, {
  type: 'tags',
  id: 'e62621fc-2e0f-47bb-9b86-f604caf65b25',
  attributes: {
    value: 'Lifestyle',
  },
  selected: false,
}, {
  type: 'tags',
  id: '752c2810-afa0-4707-8a9e-20955e9d9feb',
  attributes: {
    value: 'Fitness',
  },
  selected: false,
}, {
  type: 'tags',
  id: '67200f98-f913-41e1-88a3-bf215ffdc290',
  attributes: {
    value: 'Family',
  },
  selected: false,
}, {
  type: 'tags',
  id: '01317ff0-be15-46bc-b0de-ce5ff9d90582',
  attributes: {
    value: 'Travel',
  },
  selected: false,
}, {
  type: 'tags',
  id: '3f16f291-0599-4463-94bc-461c44d965ff',
  attributes: {
    value: 'Interior',
  },
  selected: false,
}];



/** WEBPACK FOOTER **
 ** ./src/themes/theme/tags/abbottlyon/tags.js
 **/